import {createFeatureSelector, createSelector} from '@ngrx/store';
import { StationFollowerState, stationFollowerFeatureKey } from './station-follower.reducer';

const selectStationFollowerState = createFeatureSelector<StationFollowerState>(stationFollowerFeatureKey);

export const selectStationFollowerForm = createSelector(
    selectStationFollowerState,
    state => state
);
